import { useState } from "react";

import { message } from "antd";

import { showErrorToast } from "V2.0/utils";

import PipelineDelete from "./PipelineDelete";
import PipelineDuplicate from "./PipelineDuplicate";
import PipelineListEmpty from "./PipelineListEmpty";
import PipelineListTable from "./PipelineListTable";
import PipelineListLoading from "./PipelineListLoading";

export default PipelineList;

interface PipelineListProps {
  isLoading: boolean;
  isViewOnly: boolean;
  pipelines: Array<any>;
  fetchPipelines: () => void;
  onPipelineClick: (pipelineId: string) => void;
  onPipelineDelete: (pipelineId: string, lifecycleCbs) => void;
  onPipelineEdit: (pipelineId: string) => void;
  onPipelineUpdate: (pipelineId: string, data: any, lifecycleCbs) => void;
  onPipelineDuplicate?: (pipelineId: string, name: string, lifecycleCbs) => void;
}

function PipelineList(props: PipelineListProps) {
  const {
    isLoading,
    isViewOnly,
    pipelines,
    onPipelineClick,
    onPipelineEdit,
    onPipelineDelete,
    onPipelineUpdate,
    onPipelineDuplicate,
    fetchPipelines,
  } = props;

  const [openDelete, setOpenDelete] = useState({
    pipeline: undefined,
  });

  const [openDuplicate, setOpenDuplicate] = useState({
    pipeline: undefined,
  });

  const handlePipelineDeleteClick = (pipeline) => {
    setOpenDelete({ pipeline });
  };

  const handlePipelineDuplicateClick = (pipeline) => {
    setOpenDuplicate({ pipeline });
  };

  const handlePipelineUpdate = (pipelineId: string, data: any) => {
    const lifecycleCbs = {
      init() {
        message.loading("Updating Status");
      },
      success() {
        fetchPipelines();
        message.destroy();
        message.success("Status Updated");
      },
      error(e) {
        message.destroy();
        showErrorToast(e, "Failed to Update Status");
      },
    };

    onPipelineUpdate(pipelineId, data, lifecycleCbs);
  };

  const isPipelinesEmpty = pipelines.length === 0;

  return (
    <>
      <div>
        {isLoading && <PipelineListLoading />}
        {!isLoading && isPipelinesEmpty && <PipelineListEmpty />}
        {!isLoading && !isPipelinesEmpty && (
          <PipelineListTable
            pipelines={pipelines}
            isViewOnly={isViewOnly}
            onPipelineClick={onPipelineClick}
            onPipelineUpdate={handlePipelineUpdate}
            onPipelineEdit={onPipelineEdit}
            onPipelineDelete={handlePipelineDeleteClick}
            onPipelineDuplicate={
              onPipelineDuplicate ? handlePipelineDuplicateClick : undefined
            }
          />
        )}
      </div>
      {openDelete.pipeline && (
        <PipelineDelete
          pipeline={openDelete.pipeline}
          onClose={() => setOpenDelete({ pipeline: undefined })}
          onPipelineDelete={onPipelineDelete}
        />
      )}
      {openDuplicate.pipeline && onPipelineDuplicate && (
        <PipelineDuplicate
          pipeline={openDuplicate.pipeline}
          onClose={() => setOpenDuplicate({ pipeline: undefined })}
          onPipelineDuplicate={onPipelineDuplicate}
        />
      )}
    </>
  );
}
